import React, { useEffect, useState } from "react";
import { useInternet } from "../../../../../hooks/useInternet.js";
import { Button } from "../../../../../components/button.jsx";
import { HOST } from "../../../../../hooks/constants.js";
import { useForm } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import * as zod from "zod";
import { useModal } from "../../../../../hooks/useModal.js";
import {
  GENERATE_DOCUMENT_MODAL,
  GenerateDocumentModal,
} from "./generateDocumentModal.jsx";

export function AttachmentsTab({ watch, setValue }) {
  let internet = useInternet();

  let uploadIds = watch("uploadIds") || [];
  let [selectedUpload, setSelectedUpload] = useState(null);
  let [uploadIndex, setUploadIndex] = useState(0);

  let { openModal, checkModal, closeModal } = useModal();

  let removeUpload = () => {
    setValue(
      "uploadIds",
      uploadIds.filter((id) => id != selectedUpload.id),
      { shouldDirty: true }
    );
  };

  useEffect(() => {
    if (!uploadIds[uploadIndex]) return;
    internet.get("/uploads/" + uploadIds[uploadIndex]).then(async (res) => {
      let upload = await res.json();
      setSelectedUpload(upload);
    });
  }, [uploadIndex, uploadIds]);

  let uploadNew = () => {
    return new Promise((resolve) => {
      let input = window.document.createElement("input");
      input.type = "file";
      input.multiple = true;
      input.click();

      let onFocus = () => {
        window.removeEventListener("focus", onFocus);
        if (input.files.length === 0) {
          // On cancel
          resolve();
        }
      };
      window.addEventListener("focus", onFocus);

      input.onchange = (e) => {
        let files = e.target.files;
        let data = new FormData();
        for (let file of files) data.append("files", file);
        internet.post("/uploads", data).then(async (res) => {
          let uploads = await res.json();
          setValue(
            "uploadIds",
            [...watch("uploadIds"), ...uploads.map((upload) => upload.id)],
            { shouldDirty: true }
          );
          resolve();
        });
      };
    });
  };

  let { control, watch: watch2 } = useForm({
    resolver: zodResolver(
      zod.object({ template: zod.object().passthrough().optional() })
    ),
    defaultValues: { template: null },
  });

  if (!uploadIds.length) {
    return (
      <div
        className={
          "flex flex-col h-full w-full items-center justify-center bg-white p-3"
        }
      >
        {checkModal(GENERATE_DOCUMENT_MODAL) && (
          <GenerateDocumentModal
            document={watch()}
            onUpload={(uploadId) =>
              setValue("uploadIds", watch("uploadIds").concat([uploadId]), {
                shouldDirty: true,
              })
            }
          />
        )}
        <div className={"flex flex-col gap-3"}>
          <div>This document has no attachment</div>
          <Button onClick={uploadNew}>
            Upload file
            <span className={"fa fa-upload ml-2"} />
          </Button>
          <Button onClick={() => openModal(GENERATE_DOCUMENT_MODAL)}>
            Generate document
            <span className={"fa fa-cog ml-2"} />
          </Button>
        </div>
      </div>
    );
  }

  return (
    <div className={"flex flex-col h-full w-full bg-white p-3"}>
      {selectedUpload ? (
        <>
          <div className={"flex items-center gap-3 mb-3 "}>
            {uploadIndex > 0 && (
              <Button onClick={() => setUploadIndex(uploadIndex - 1)}>
                Prev
              </Button>
            )}
            <div
              className={
                "flex-grow text-center flex gap-3 items-center justify-center"
              }
            >
              {uploadIds.length > 0 && (
                <div>
                  {uploadIndex + 1} / {uploadIds.length} [
                  {selectedUpload.filename}]
                </div>
              )}
              <Button sizing={"s"} onClick={removeUpload}>
                remove
              </Button>
              <Button sizing={"s"} onClick={uploadNew}>
                upload
              </Button>
            </div>
            {uploadIndex < uploadIds.length - 1 && (
              <Button onClick={() => setUploadIndex(uploadIndex + 1)}>
                next
              </Button>
            )}
          </div>
          <div className={"flex-grow overflow-auto"}>
            {selectedUpload?.filename && (
              <>
                {selectedUpload.filename.endsWith(".pdf") ? (
                  <iframe
                    src={`${HOST}/uploads/${selectedUpload.id}/download?token=${window.localStorage.token}`}
                    className={"min-w-full min-h-full h-full w-full"}
                  />
                ) : (
                  <img
                    src={`${HOST}/uploads/${selectedUpload.id}/download?token=${window.localStorage.token}`}
                    className={"min-w-full min-h-full h-full w-full"}
                    style={{ objectFit: "contain" }}
                  />
                )}
              </>
            )}
          </div>
        </>
      ) : (
        <div>Loading...</div>
      )}
    </div>
  );
}
